module.exports = __webpack_public_path__ + "static/news3-83593d2fea8a9c015a802c0ebe29462d.png";